import React from 'react';
import { useAbMarkSuccess } from '../../hooks';

interface MarkSuccessOnClickProps {
  testSlug: string;
  successType: string;
}

export const MarkSuccessOnClick: React.FunctionComponent<MarkSuccessOnClickProps> = ({
  children,
  testSlug,
  successType,
}) => {
  const { markSuccess } = useAbMarkSuccess(testSlug, successType);

  return <div onClick={markSuccess}>{children}</div>;
};
